import { TIPO_LEAD_LABELS } from '@idpe/schema';
import { createFileRoute, Link } from '@tanstack/react-router';

import { Badge } from '~/components/ui/Badge.js';
import { Button } from '~/components/ui/Button.js';
import { Spinner } from '~/components/ui/Spinner.js';
import { TIPO_TONE, leadFields, leadFrom } from '~/features/leads/display.js';
import { useLead } from '~/features/leads/hooks.js';

export const Route = createFileRoute('/_auth/leads/$id')({
  component: LeadDetailPage,
});

function LeadDetailPage() {
  const { id } = Route.useParams();
  const { data: lead, isLoading, error } = useLead(id);

  if (isLoading) {
    return (
      <div className="page">
        <div className="dt__state">
          <Spinner size="lg" />
        </div>
      </div>
    );
  }

  if (error || !lead) {
    return (
      <div className="page">
        <header className="page-head">
          <p className="eyebrow">/ Erro</p>
          <h1 className="page-title">Mensagem não encontrada.</h1>
        </header>
        <Link to="/leads">
          <Button variant="secondary">Voltar à lista</Button>
        </Link>
      </div>
    );
  }

  const fields = leadFields(lead);
  const recebidoEm = new Date(lead.criadoEm).toLocaleString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className="page">
      <header className="page-head">
        <p className="eyebrow">/ Relacionamento · Mensagens</p>
        <h1 className="page-title">{leadFrom(lead)}</h1>
        <p className="page-sub">
          <Badge tone={TIPO_TONE[lead.tipo]}>{TIPO_LEAD_LABELS[lead.tipo]}</Badge> · recebido em{' '}
          {recebidoEm}
        </p>
      </header>

      <section className="form-card">
        <h2 className="form-card__title">Dados enviados</h2>
        <dl className="lead-detail">
          {fields.map((f) => (
            <div className="lead-detail__row" key={f.label}>
              <dt className="lead-detail__label">{f.label}</dt>
              <dd className="lead-detail__value">{f.value}</dd>
            </div>
          ))}
        </dl>
      </section>

      <Link to="/leads">
        <Button variant="ghost">← Voltar à lista</Button>
      </Link>
    </div>
  );
}
